<template>
	<v-container class="pt-6">
	  <v-row justify="center">

	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" sm="8" md="6" lg="4" class="pb-1">
	  		<v-card class="elevation-0 shadowCard">
	  			<v-card-text>
	  				<v-row>
	  					<v-col cols="9">
	  						<div>
			            <p class="mb-0 font-weight-bold">
			              {{ getGrupo.grupo.grupo_corto }}
			            </p>

			            <h5 class="mb-0 font-weight-bold text-h6 colorCurso" >
			              {{ getGrupo.escuela.curso }}<br/>
			            </h5>
		              <span class="text-sm font-weight-bolder grey--text">
		                <strong>{{ getGrupo.grupo.hora_inicio }} a {{ getGrupo.grupo.hora_fin }}</strong>
		              </span>
			          </div>
	  					</v-col>

	  					<v-col cols="2">
		            <v-avatar
			            size="60"
			            color="transparent"
			            rounded
			            class="elevation-1 avatares shadowCard"
			          >
			            <span class="text-h4 white--text">{{ getGrupo.grupo.id_nivel }}</span>
			          </v-avatar>
	  					</v-col>
	  				</v-row>
	  			</v-card-text>
	  		</v-card>
	  	
	  		<v-card class="shadowCard mt-2">
		  		<v-list flat>
		  			<v-subheader>Opciones del grupo</v-subheader>
			      <v-list-item-group
			        v-model="model"
			        color="primary"
			      >
			        <v-list-item
			          v-for="(item, i) in opcionesGrupo"
			          :key="i"
			          :to="{ name: item.path }"
			        >
			          <v-list-item-icon>
			            <v-icon v-text="item.icon" color="primary"></v-icon>
			          </v-list-item-icon>

			          <v-list-item-content>
			            <v-list-item-title v-text="item.opcion"></v-list-item-title>
			          </v-list-item-content>
			        </v-list-item>
			      </v-list-item-group>
			    </v-list>
	  		</v-card>

	  		<v-card class="shadowCard mt-2" v-if="getUsuarioLMS.accesoweb" @click="abrirSistem()">
	  			<v-card-title primary-title>
	  			  Abrir sistema Adults
	  			</v-card-title>
	  		</v-card>

	  		<v-card class="shadowCardAsistencia mt-2" v-if="existeCodigo">
	  			<v-card-title primary-title class="white--text">
	  			  Validar Asistencia
	  			</v-card-title>
	  			<v-card-text>
			  		<v-otp-input
			        v-model="codigo"
			        :disabled="cargar"
			        @finish="onFinish"
			      ></v-otp-input>
			      <v-overlay absolute :value="cargar">
			        <v-progress-circular
			          indeterminate
			          color="primary"
			        ></v-progress-circular>
			      </v-overlay>
	  			</v-card-text>
	  		</v-card>
	  	</v-col>

	  	<!-- Información del grupo -->
	  	<v-col cols="12" sm="8" md="6" lg="4" class="pb-1">
	  		<!-- Información -->
	  		<Informacion/>

	  		<!-- Ponderación -->
	  		<Ponderacion class="mt-2"/>
	  	</v-col>


	  </v-row>

	  <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

	</v-container>
</template>
<script>

	const base64 = require("base-64");

	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta        from '@/components/alertas/Alerta.vue'
  import Loader        from '@/components/alertas/Loader.vue'
  
  import Ponderacion   from '@/components/grupos/Ponderacion.vue'
  import Informacion   from '@/components/grupos/Informacion.vue'


	export default {
	  name: "dashboard-default",
	  data: () => ({
    	respuestaAlerta: false,

      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},

     	opcionesGrupo: [
        {
        	path:   'ListaAlumnos',
          icon:   'mdi-account-multiple',
          opcion: 'Lista de alumnos',
        },
        {
        	path:   'RecursoGrupo',
          icon:   'mdi-file-document-edit',
          opcion: 'Recursos asignados',
        },
        {
        	path:   'ListaAsistencia',
          icon:   'mdi-account-check',
          opcion: 'Participación',
        },
        {
        	path:   'CalificacionGrupo',
          icon:   'mdi-book-check',
          opcion: 'Calificaciones',
        },
        {
        	path:   'Incidencias',
          icon:   'mdi-account-multiple',
          opcion: 'Incidencias',
        },
      ],
      model: null,

      existeCodigo: false,
      codigo: null,

	  }),

	  components: {
	    Alerta,
	    Loader,
	    Ponderacion,
	    Informacion
	  },

	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS' ])
	  },

	  created ( ){
	  	this.validarExisteCodigo( )
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirRecursosAlumno', 'abrirCalificaciones' ] ),

			validarExisteCodigo ( ){
				const payload = {
		  		id_usuario: this.getUsuarioLMS.iderp,
		  		id_grupo  : this.getGrupo.grupo.id
		  	}

    		this.cargar = true
  			// Hacemos la consulta
    		this.$http.post('grupos.existe.codigo', payload ).then( response=> {
    			this.existeCodigo = true
    		}).catch( error =>{
    			// this.validarError( error )
    		}).finally( () => { this.cargar = false })
    	},

    	onFinish (rsp) {
        this.loading = true
        this.cargar = true
  			// Hacemos la consulta
  			const payload = {
		  		id_usuario: this.getUsuarioLMS.iderp,
		  		id_grupo  : this.getGrupo.grupo.id,
		  		codigo    : this.codigo
		  	}

    		this.$http.post('grupos.validar.codigo', payload ).then( response=> {
    			this.codigo       = null
    			this.existeCodigo = false
    			this.validarSuccess( 'Asistencia grabada correctamente' )
    			this.validarExisteCodigo( )
    		}).catch( error =>{
    			this.validarError( error )
    		}).finally( () => { this.cargar = false })
      },

    	validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },	  

      validarSuccess( mensaje ){
      	this.cargar = false 
        this.parametros.mensaje      = mensaje
        this.parametros.dialogError  = true 
        this.parametros.color        = 'green'
        this.respuestaAlerta = true 
      },


      abrirSistem( ){

      	let baseCode = base64.encode(this.getUsuarioLMS.id);

      	window.open('https://www.fastenglish.com.mx/adults/#/' + baseCode )
      },

	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCardAsistencia{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
		background: rgb(59,137,199);
		background: linear-gradient(90deg, rgba(59,137,199,1) 0%, rgba(0,53,194,1) 100%);
	}

	.recursos{
		background: rgb(233,186,255);
		background: linear-gradient(90deg, rgba(233,186,255,1) 0%, rgba(186,52,251,1) 100%);
	}

	.calificaciones{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.colorCurso{
		color: #006093;
	}

	.position-relative {
    position: relative;
  }

</style>
